/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ManualEmailStepOverrideEmailThreadMode = typeof ManualEmailStepOverrideEmailThreadMode[keyof typeof ManualEmailStepOverrideEmailThreadMode] | null;


export const ManualEmailStepOverrideEmailThreadMode = {
  new_thread: 'new_thread',
  reply: 'reply',
} as const;
